import "./Process.module.css";
import Header from "@/reusable_sections/Header";
import TheThreeStepPath from "./sections/TheThreeStepPath";
import GlobalOperationalManagement from "./sections/GlobalOperationalManagement";
import ASimpleWayToBuildYourTeamInBrazil from "./sections/ASimpleWayToBuildYourTeamInBrazil";
import ReadyToDeploy from "./sections/ReadyToDeploy";
import Footer from "@/reusable_sections/Footer";
export default function ProcessPage() {
  return <div>
      <Header />
      <TheThreeStepPath />
      <GlobalOperationalManagement />
      <ASimpleWayToBuildYourTeamInBrazil />
      <ReadyToDeploy />
      <Footer />
    </div>;
}